import {
  EditorChangeEvent,
  Editor as KendoEditor,
  EditorProps as KendoEditorProps,
} from '@progress/kendo-react-editor';
import { InputChangeEvent } from '@progress/kendo-react-inputs';
import _ from 'lodash';
import React from 'react';
import { ValidationError } from '../../apps/benefit/models/Errors';
import useToggleClass from '../hooks/useToggleClass';
import ErrorViewer from './ErrorViewer';

export interface EditorProps {
  controlClassName?: string;
  helper?: string;
  mandatory?: boolean;
  label?: string;
  onChange?: (e: InputChangeEvent) => void;
  errors?: ValidationError[];
  clearErrors?: () => void;
}

export default function Editor(props: EditorProps & KendoEditorProps) {
  const ref = React.useRef<HTMLDivElement | null>(null);

  const { addClass, removeClass } = useToggleClass();
  const {
    controlClassName,
    helper,
    mandatory,
    label,
    errors,
    onChange,
    clearErrors,
  } = props;

  const internalOnChange = (e: EditorChangeEvent) => {
    if (errors?.length) {
      clearErrors?.();
    }
    onChange?.(e);
  };

  const classNames = `control-group ${controlClassName ?? ''}`.trim();

  React.useEffect(() => {
    errors && errors?.length > 0
      ? addClass('control-error', ref)
      : removeClass('control-error', ref);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return (
    <div className={classNames} ref={ref}>
      <div className="control-content">
        {!!label && (
          <label>
            {label}
            {mandatory && <sup>*</sup>}
          </label>
        )}
        <KendoEditor
          {..._.omit(props, ['label', 'mandatory', 'clearErrors'])}
          onChange={internalOnChange}
        />
      </div>
      {!!helper && <div className="control-info">{helper}</div>}
      <ErrorViewer errors={errors} />
    </div>
  );
}
